import { createListLoadingReducer } from './utils';
import { BookingStatus } from '@/types';

export default createListLoadingReducer<BookingStatus>('BOOKING_STATUSES');
